import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinButtonClick } from '@packages/tracking/src/types/events';
import type { CustomerReviewsSort } from '../../../CustomerRatingsAndReviewsPage/SortSelection/getSortParams';
import { getSortingSelectionDetailValue } from './getSortingSelectionDetailValue';

const defaults: Pick<GTMEventGlycerinButtonClick['ButtonClickData'], 'label' | 'category'> = {
  label: 'Kundenbewertungen',
  category: 'Sortierung',
};

export const useCustomerRatingsTracking = () => {
  const dispatchTracking = useTracking();

  const trackSortingSelection = (sortedBy: CustomerReviewsSort) => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: { ...defaults, detail: getSortingSelectionDetailValue(sortedBy) },
    });
  };

  return {
    trackSortingSelection,
  };
};
